module.exports = __webpack_public_path__ + "static/media/MY.1a0cb986.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MY.svg
// module id = 324
// module chunks = 0